import { render, staticRenderFns } from "./CostBearerExistingProducts.vue?vue&type=template&id=decccb6c&scoped=true"
import script from "./CostBearerExistingProducts.vue?vue&type=script&lang=ts"
export * from "./CostBearerExistingProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decccb6c",
  null
  
)

export default component.exports